<div
  class="gw-relative gw-flex gw-flex-col gw-gap-medium sm:gw-flex-row sm:gw-items-start gw-p-medium"
>
  <div class="gw-min-w-0 gw-flex-1">
    <h3
      class="gw-mb-2x-small gw-text-base gw-font-semibold gw-text-text-primary"
    >
      {{ 'features.dashboard.cards.invoicesByPaymentMethod.title' | translate }}
    </h3>
    <p class="gw-mb-0 gw-text-sm gw-text-text-secondary">
      {{
        'features.dashboard.cards.invoicesByPaymentMethod.description'
          | translate
      }}
    </p>
  </div>

  <div
    *ngIf="!isLoading && availableMonths.length > 0"
    class="gw-flex gw-flex-wrap gw-gap-2x-small sm:gw-ml-auto"
  >
    <button
      *ngFor="let month of availableMonths"
      type="button"
      class="gw-rounded-full gw-border gw-border-solid gw-px-small gw-py-2x-small gw-text-xs gw-font-medium gw-transition-colors focus:gw-outline-none focus:gw-ring-2 focus:gw-ring-border-focus"
      [ngClass]="
        currentIndex === month.index
          ? 'gw-border-background-accent-1 gw-bg-background-accent-1 gw-text-text-primary-on-accent-1'
          : 'gw-border-border-normal gw-bg-transparent gw-text-text-secondary hover:gw-border-border-hover'
      "
      (click)="selectMonth(month.index)"
    >
      {{ month.label | relativeTime }}
    </button>
  </div>

  <div *ngIf="isLoading" class="sm:gw-ml-auto">
    <gatewee-element-spinner></gatewee-element-spinner>
  </div>
</div>

<div class="gw-p-medium gw-pt-0">
  <!-- Skeleton Loading State -->
  <div
    *ngIf="isLoading"
    class="gw-grid gw-grid-cols-1 gw-items-center gw-gap-medium md:gw-grid-cols-2"
  >
    <div class="gw-flex gw-flex-col gw-gap-large">
      <div
        *ngFor="let i of [1, 2, 3]"
        class="gw-flex gw-animate-pulse gw-gap-medium"
      >
        <div
          class="gw-h-[54px] gw-w-[14px] gw-flex-shrink-0 gw-rounded-full gw-bg-background-neutral-2"
        ></div>
        <div class="gw-flex gw-flex-1 gw-flex-col gw-gap-2x-small">
          <div
            class="gw-h-3 gw-w-20 gw-rounded gw-bg-background-neutral-2"
          ></div>
          <div
            class="gw-h-5 gw-w-28 gw-rounded gw-bg-background-neutral-2"
          ></div>
        </div>
      </div>
    </div>
    <div class="gw-grid gw-grid-cols-1 gw-gap-medium sm:gw-grid-cols-2">
      <div
        *ngFor="let i of [1, 2, 3]"
        class="gw-animate-pulse gw-rounded-xl gw-bg-background-neutral-1 gw-p-medium gw-text-center"
      >
        <div
          class="gw-mx-auto gw-mb-medium gw-h-[90px] gw-w-[90px] gw-rounded-full gw-bg-background-neutral-2"
        ></div>
        <div
          class="gw-mx-auto gw-h-3 gw-w-24 gw-rounded gw-bg-background-neutral-2"
        ></div>
      </div>
    </div>
  </div>

  <!-- No Data State -->
  <div *ngIf="hasNoData" class="gw-text-center gw-py-x-large">
    <svg
      width="80"
      height="80"
      viewBox="0 0 24 24"
      fill="none"
      xmlns="http://www.w3.org/2000/svg"
      class="gw-mb-medium gw-text-text-tertiary"
    >
      <circle cx="12" cy="12" r="10" stroke="currentColor" stroke-width="1.5" />
      <path
        d="M12 7v6m0 4h.01"
        stroke="currentColor"
        stroke-width="1.5"
        stroke-linecap="round"
      />
    </svg>
    <h4
      class="gw-mb-2x-small gw-text-base gw-font-semibold gw-text-text-secondary"
    >
      {{
        'features.dashboard.cards.invoicesByPaymentMethod.emptyTitle'
          | translate
      }}
    </h4>
    <p class="gw-mb-0 gw-text-sm gw-text-text-tertiary">
      {{
        'features.dashboard.cards.invoicesByPaymentMethod.emptyDescription'
          | translate
      }}
    </p>
  </div>

  <!-- Actual Content -->
  <div
    *ngIf="!isLoading && !hasNoData"
    class="gw-grid gw-grid-cols-1 gw-items-center gw-gap-medium md:gw-grid-cols-2"
  >
    <div class="gw-flex gw-flex-col gw-gap-large">
      <div *ngFor="let invoice of invoices" class="gw-flex gw-gap-medium">
        <svg
          class="gw-flex-shrink-0"
          width="14"
          height="54"
          viewBox="0 0 14 54"
          fill="none"
          xmlns="http://www.w3.org/2000/svg"
        >
          <rect width="14" height="54" rx="7" [attr.fill]="primaryColor" />
        </svg>
        <div class="gw-min-w-0">
          <p class="gw-mb-2x-small gw-text-sm gw-text-text-primary">
            {{ invoice.paymentMethod | paymentMethod }}
          </p>
          <span class="gw-text-lg gw-font-semibold gw-text-text-primary">{{
            invoice.totalAmount
              | currency : 'BRL' : 'symbol' : '1.2-2' : 'pt-BR'
          }}</span>
        </div>
      </div>
    </div>
    <div class="gw-grid gw-grid-cols-1 gw-gap-medium sm:gw-grid-cols-2">
      <div
        *ngFor="let invoice of invoices"
        class="gw-bg-background-accent-1 gw-rounded-xl gw-p-medium gw-text-center"
      >
        <div
          class="gw-relative gw-mx-auto gw-mb-medium gw-inline-block gw-h-[90px] gw-w-[90px]"
        >
          <svg
            class="gw-block gw-h-full gw-w-full gw-text-text-primary-on-accent-1"
            height="90"
            width="90"
            viewBox="0 0 90 90"
          >
            <circle
              cx="45"
              cy="45"
              r="40"
              fill="none"
              stroke="currentColor"
              stroke-opacity="0.25"
              stroke-width="10"
            ></circle>
            <circle
              cx="45"
              cy="45"
              r="40"
              fill="none"
              stroke="currentColor"
              stroke-width="10"
              stroke-linecap="round"
              [attr.stroke-dasharray]="circumference"
              [attr.stroke-dashoffset]="calculateOffset(invoice.percentage)"
              style="transform: rotate(-90deg); transform-origin: center"
            ></circle>
          </svg>
          <div
            class="gw-pointer-events-none gw-absolute gw-inset-0 gw-flex gw-items-center gw-justify-center"
          >
            <span
              class="gw-text-xs gw-font-semibold gw-text-text-primary-on-accent-1"
            >
              {{ invoice.percentage }}%
            </span>
          </div>
        </div>
        <span class="gw-block gw-text-sm gw-text-text-primary-on-accent-1">
          {{ invoice.paymentMethod | paymentMethod }}
        </span>
      </div>
    </div>
  </div>
</div>
